export default "__VITE_ASSET__Bx_ZM315__"